import { STORAGE_KEY_RECENT_SEARCHES, MAX_RECENT_SEARCHES } from './constants';

export function cleanQuery(query: string): string {
  return query.trim().replace(/\s+/g, ' ');
}

export function matchesQuery(query: string, lastQuery: string): boolean {
  return cleanQuery(query).toLowerCase() === cleanQuery(lastQuery).toLowerCase();
}

export function getRecentSearches(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_RECENT_SEARCHES);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.filter(item => typeof item === 'string');
    }
    return [];
  } catch (error) {
    console.error('Error reading recent searches', error);
    return [];
  }
}

export function saveRecentSearch(query: string): string[] {
  const cleaned = cleanQuery(query);
  if (!cleaned || cleaned.length < 3) return getRecentSearches();

  try {
    const list = getRecentSearches();
    const filtered = list.filter(item => item.toLowerCase() !== cleaned.toLowerCase());
    const newList = [cleaned, ...filtered].slice(0, MAX_RECENT_SEARCHES);
    localStorage.setItem(STORAGE_KEY_RECENT_SEARCHES, JSON.stringify(newList));
    return newList;
  } catch (error) {
    console.error('Error saving recent search', error);
    return getRecentSearches();
  }
}
